import { Model } from '@vuex-orm/core'

export default class Placement extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'placements'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      candidate_id: this.attr(null),
      job_id: this.attr(null),
      stage_id: this.attr(null),
      stage_date: this.attr(null),
      hired: this.attr(null),
      hired_date: this.attr(null),
      status: this.attr(null),
      disqualify_reason_id: this.attr(null),
      referral_email: this.attr(null),
      referral_name: this.attr(null),
      application_answers: this.attr(null),
      new: this.attr(null),
      author_user_id: this.attr(null),
      account_id: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Placement.js